import React, { useState, useEffect, useRef } from "react";
import icon_edit from "../assets/icons/icon-edit.svg";
function EditableText(props) {
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(props.text);
  const isClicked = useRef(null);
  const handleDoubleClick = () => {
    setIsEditing((value) => !value);
  };

  const handleBlur = () => {
    setIsEditing(false);
    props.onChange(text);
  };

  const handleChange = (event) => {
    setText(event.target.value);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isClicked.current && !isClicked.current.contains(event.target)) {
        handleBlur();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className="flex flex-row pr-[10px]">
      {isEditing ? (
        <input
          onChange={handleChange}
          ref={isClicked}
          onKeyDown={(e) => e.key === "Enter" && handleBlur()}
          type="text"
          className="text-sans w-[600px] font-bold text-black text-base md:text-4xl border-b border-gray-500 focus:outline-none focus:border-blue-500"
          value={text}
          onBlur={handleBlur}
          autoFocus
        />
      ) : (
        <h1
          data-cy="todo-title"
          className="text-sans font-bold text-black text-base md:text-4xl"
          onClick={handleDoubleClick}
        >
          {text}
        </h1>
      )}
      <img
        data-cy="todo-title-edit-button"
        onClick={handleDoubleClick}
        className="ml-5 cursor-pointer"
        alt="edit-title-button"
        src={icon_edit}
      />
    </div>
  );
}

export default EditableText;
